import { GetApiTimesheetsError, GetApiTimesheetsResponse, useGetTimesheets as useGetApiTimesheets } from '@sit/client-shared';
import { QueryKey, skipToken, UseQueryOptions } from '@tanstack/react-query';
import { useIncludeEntityData } from '@web/containers/Timesheets/hooks/useIncludeEntityData';
import { useIsStaff } from '@web/containers/Timesheets/hooks/useIsStaff';
import { useCurrentEntity } from '@web/hooks/use-current-entity';

export function useGetTimesheets(
  options?:
    | Omit<
        UseQueryOptions<GetApiTimesheetsResponse, GetApiTimesheetsError, GetApiTimesheetsResponse, QueryKey>,
        'queryKey' | 'queryFn' | 'initialData'
      >
    | undefined,
) {
  const companyId = useCurrentEntity()?.id;
  const staff = useIsStaff();
  const includePrivate = useIncludeEntityData();
  return useGetApiTimesheets(
    companyId
      ? {
          queryParams: {
            includePrivate: includePrivate ? 'true' : undefined,
            staff: staff ? 'true' : undefined,
            companyId,
          },
        }
      : skipToken,
    {
      staleTime: 1000 * 5, // 5 seconds
      ...options,
    },
  );
}
